import React from 'react';
import { Shield, Twitter, Linkedin, Github } from 'lucide-react';
export function Footer() {
  return <footer className="bg-slate-900 text-slate-300 py-16" data-id="element-41">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-42">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12" data-id="element-43">
          <div className="col-span-1 md:col-span-2" data-id="element-44">
            <div className="flex items-center space-x-2 mb-6" data-id="element-45">
              <Shield className="h-8 w-8 text-white" data-id="element-46" />
              <span className="text-2xl font-bold text-white tracking-tight" data-id="element-47">
                Dataprixa
              </span>
            </div>
            <p className="text-slate-400 max-w-md mb-6 leading-relaxed" data-id="element-48">
              An independent editorial platform dedicated to delivering in-depth
              analysis and practical insights on data infrastructure, digital
              security, and ethical data practices.
            </p>
            <div className="flex space-x-4" data-id="element-49">
              <a href="#" className="text-slate-400 hover:text-white transition-colors" data-id="element-50">
                <Twitter className="h-5 w-5" data-id="element-51" />
                <span className="sr-only" data-id="element-52">Twitter</span>
              </a>
              <a href="#" className="text-slate-400 hover:text-white transition-colors" data-id="element-53">
                <Linkedin className="h-5 w-5" data-id="element-54" />
                <span className="sr-only" data-id="element-55">LinkedIn</span>
              </a>
              <a href="#" className="text-slate-400 hover:text-white transition-colors" data-id="element-56">
                <Github className="h-5 w-5" data-id="element-57" />
                <span className="sr-only" data-id="element-58">GitHub</span>
              </a>
            </div>
          </div>

          <div data-id="element-59">
            <h3 className="text-white font-semibold mb-6" data-id="element-60">Platform</h3>
            <ul className="space-y-4" data-id="element-61">
              <li data-id="element-62">
                <a href="#analysis" className="hover:text-white transition-colors" data-id="element-63">
                  Analysis
                </a>
              </li>
              <li data-id="element-64">
                <a href="#topics" className="hover:text-white transition-colors" data-id="element-65">
                  Topics
                </a>
              </li>
              <li data-id="element-66">
                <a href="#about" className="hover:text-white transition-colors" data-id="element-67">
                  About Us
                </a>
              </li>
              <li data-id="element-68">
                {/* REQUIRED DOFOLLOW LINK */}
                <a href="https://dataprixa.com/" className="hover:text-white transition-colors font-medium text-blue-400" data-id="element-69">
                  Dataprixa.com
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-70">
            <h3 className="text-white font-semibold mb-6" data-id="element-71">Legal</h3>
            <ul className="space-y-4" data-id="element-72">
              <li data-id="element-73">
                <a href="#" className="hover:text-white transition-colors" data-id="element-74">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-75">
                <a href="#" className="hover:text-white transition-colors" data-id="element-76">
                  Terms of Service
                </a>
              </li>
              <li data-id="element-77">
                <a href="#" className="hover:text-white transition-colors" data-id="element-78">
                  Cookie Policy
                </a>
              </li>
              <li data-id="element-79">
                <a href="#" className="hover:text-white transition-colors" data-id="element-80">
                  Editorial Guidelines
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-81">
          <p className="text-sm text-slate-500" data-id="element-82">
            &copy; {new Date().getFullYear()} Dataprixa. All rights reserved.
          </p>
          <p className="text-sm text-slate-500 mt-2 md:mt-0" data-id="element-83">
            Designed for data professionals.
          </p>
        </div>
      </div>
    </footer>;
}